<div class="component is-3d is-pointer-events-none"
  [style.width.px]="width * gridSize" [style.height.px]="depth * gridSize"
  appMovable [movable.option]="movableOption" [movable.disable]="isLocked" (movable.ondragstart)="onMove()" (movable.ondragend)="onMoved()">
  <div class="component-content is-3d is-pointer-events-auto" [ngClass]="{'is-grab': !isLocked || isLocked}"
       appRotable [rotable.option]="rotableOption" (rotable.ondragstart)="onMove()" (rotable.ondragend)="onMoved()" [rotable.disable]="isLocked">
    <ng-container *ngIf="hasFloor && isVisibleFloor && 0 < floorImage?.url.length">
      <!--<div class="texture" [ngClass]="{'blinking-animation': isLocked}" [ngStyle]="{'transform': 'translateZ(' + height * gridSize +'px)'}"
  [style.background-image]="'url(' + floorImage.url + ')' | safe: 'style'"></div>-->
      <div *ngIf="terrain.timer_A_flag == true && terrain.name == '隠駒'" class="name-tag_A is-nowrap is-black-background has-length-limit" [ngStyle]="{'transform': 'translateY(700%) translateX(105%)'}">
        <span *ngIf="terrain.timer_A_min < 10">0</span>
        <span>{{terrain.timer_A_min}}</span>
        <span>:</span>
        <span *ngIf="terrain.timer_A_sec < 10">0</span>
        <span>{{terrain.timer_A_sec}}</span>
      </div>
      <div *ngIf="terrain.timer_A_flag == true && terrain.name == '隠駒'" class="name-tag_B is-nowrap is-black-background has-length-limit" [ngStyle]="{'transform': 'translateY(0%) translateX(105%) rotate(180deg)'}">
        <span *ngIf="terrain.timer_B_min < 10">0</span>
        <span>{{terrain.timer_B_min}}</span>
        <span>:</span>
        <span *ngIf="terrain.timer_B_sec < 10">0</span>
        <span>{{terrain.timer_B_sec}}</span>
      </div>
      <div *ngIf="terrain.timer_B_flag == true && terrain.name == '隠駒'" class="name-tag_A is-nowrap is-black-background has-length-limit" [ngStyle]="{'transform': 'translateY(0%) translateX(105%) rotate(180deg)'}">
        <span *ngIf="terrain.timer_A_min < 10">0</span>
        <span>{{terrain.timer_A_min}}</span>
        <span>:</span>
        <span *ngIf="terrain.timer_A_sec < 10">0</span>
        <span>{{terrain.timer_A_sec}}</span>
      </div>
      <div *ngIf="terrain.timer_B_flag == true && terrain.name == '隠駒'" class="name-tag_B is-nowrap is-black-background has-length-limit" [ngStyle]="{'transform': 'translateY(700%) translateX(105%)'}">
        <span *ngIf="terrain.timer_B_min < 10">0</span>
        <span>{{terrain.timer_B_min}}</span>
        <span>:</span>
        <span *ngIf="terrain.timer_B_sec < 10">0</span>
        <span>{{terrain.timer_B_sec}}</span>
      </div>
      <div class="texture" [ngClass]="" [ngStyle]="{'transform': 'translateZ(' + height * gridSize +'px)'}"
           [style.background-image]="'url(' + floorImage.url + ')' | safe: 'style'"></div>
    </ng-container>
    <!--<ng-container *ngIf="hasWall && 0 < wallImage?.url.length">
  <div *ngIf="isVisibleWallTopBottom" [ngClass]="{'blinking-animation': isLocked}"
    class="texture of-wall-top" [style.background-image]="'url(' + wallImage.url + ')' | safe: 'style'"
    [style.width.px]="width * gridSize" [style.height.px]="height * gridSize"></div>
  <div *ngIf="isVisibleWallTopBottom" [ngClass]="{'blinking-animation': isLocked}"
    class="texture of-wall-bottom" [style.background-image]="'url(' + wallImage.url + ')' | safe: 'style'"
    [style.width.px]="width * gridSize" [style.height.px]="height * gridSize"></div>
  <div *ngIf="isVisibleWallLeftRight" [ngClass]="{'blinking-animation': isLocked}"
    class="texture of-wall-left" [style.background-image]="'url(' + wallImage.url + ')' | safe: 'style'"
    [style.width.px]="depth * gridSize" [style.height.px]="height * gridSize"></div>
  <div *ngIf="isVisibleWallLeftRight" [ngClass]="{'blinking-animation': isLocked}"
    class="texture of-wall-right" [style.background-image]="'url(' + wallImage.url + ')' | safe: 'style'"
    [style.width.px]="depth * gridSize" [style.height.px]="height * gridSize"></div>-->
    <ng-container *ngIf="hasWall && 0 < wallImage?.url.length">
      <div *ngIf="isVisibleWallTopBottom" [ngClass]=""
           class="texture of-wall-top" [style.background-image]="'url(' + wallImage.url + ')' | safe: 'style'"
           [style.width.px]="width * gridSize" [style.height.px]="height * gridSize"></div>
      <div *ngIf="isVisibleWallTopBottom" [ngClass]=""
           class="texture of-wall-bottom" [style.background-image]="'url(' + wallImage.url + ')' | safe: 'style'"
           [style.width.px]="width * gridSize" [style.height.px]="height * gridSize"></div>
      <div *ngIf="isVisibleWallLeftRight" [ngClass]=""
           class="texture of-wall-left" [style.background-image]="'url(' + wallImage.url + ')' | safe: 'style'"
           [style.width.px]="depth * gridSize" [style.height.px]="height * gridSize"></div>
      <div *ngIf="isVisibleWallLeftRight" [ngClass]=""
           class="texture of-wall-right" [style.background-image]="'url(' + wallImage.url + ')' | safe: 'style'"
           [style.width.px]="depth * gridSize" [style.height.px]="height * gridSize"></div>
    </ng-container>
    <ng-container *ngIf="!isLocked">
      <!--<div class="pedestal-grab rotate-grab"></div>
    <div class="rotate-grab of-left-top rotate-grab-icon">
      <i class="material-icons">autorenew</i>
    </div>
    <div class="rotate-grab of-left-bottom rotate-grab-icon">
      <i class="material-icons">autorenew</i>
    </div>
    <div class="rotate-grab of-right-bottom rotate-grab-icon">
      <i class="material-icons">autorenew</i>
    </div>
    <div class="rotate-grab of-right-top rotate-grab-icon">
      <i class="material-icons">autorenew</i>
    </div>-->
    </ng-container>
  </div>
</div>
